import { useState } from "react";
import { Phone, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";


export default function CallbackButton() {
  const [open, setOpen] = useState(false);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", comment: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("https://api.kt-mebel.ru/callback", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      if (res.ok) {
        setSent(true);
        setForm({ name: "", phone: "", comment: "" });
      } else {
        alert("Ошибка отправки. Попробуйте позже");
      }
    } catch (err) {
      alert("Сервер недоступен");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Floating Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <motion.button
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setOpen(true)}
          className="bg-[#0081AA] hover:bg-[#006d90] text-white p-4 rounded-full shadow-[0_8px_25px_rgba(0,129,170,0.25)] flex items-center justify-center"
        >
          <Phone size={20} />
        </motion.button>
      </div>

      {/* Modal */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
            onClick={() => setOpen(false)}
          >
            <motion.div
              initial={{ y: 40, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 40, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
              className="relative bg-white rounded-2xl p-6 w-[90%] max-w-sm shadow-xl"
            >
              {/* Close (X) */}
              <button
                onClick={() => setOpen(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-black transition"
                aria-label="Закрыть"
              >
                <X size={20} />
              </button>

              <h2 className="text-xl font-semibold mb-4 pr-8">Заказать звонок</h2>

              {sent ? (
                <p className="text-green-600 text-sm">
                  Спасибо! Мы скоро вам перезвоним
                </p>
              ) : (
                <form onSubmit={handleSubmit} className="flex flex-col gap-3">
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Ваше имя"
                    required
                    className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-[#0081AA]"
                  />

                  <input
                    type="tel"
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder="Телефон"
                    required
                    className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-[#0081AA]"
                  />

                  <textarea
                    name="comment"
                    value={form.comment}
                    onChange={handleChange}
                    placeholder="Комментарий (необязательно)"
                    rows={3}
                    className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-[#0081AA] resize-none"
                  />

                  <button
                    type="submit"
                    disabled={loading}
                    className="bg-[#0081AA] text-white py-2 rounded-lg hover:bg-[#006d90] transition disabled:opacity-60"
                  >
                    {loading ? "Отправка..." : "Отправить"}
                  </button>
                </form>
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
